export function deepCloneObject(obj: any): any {
  return JSON.parse(JSON.stringify(obj));
}
